import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { FormalizationService } from 'src/app/services/formalization/formalization.service';
import { SessionService } from 'src/app/services/session/session.service';
import { LoadingService } from '../../loading/loading-service.service';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  btnOneIcon:string,
  textBtnOne:string,
  textBtnTwo:string,
  textExtra:string,
  textLink:string,
  proposalID:string,
  routerContentLink:string,
  infoBoxIcon:string,
  infoBoxSpan:string,
  infoBoxNumber:string,
}

@Component({
  selector: 'app-modal-auth-debit',
  templateUrl: './modal-auth-debit.component.html',
  styleUrls: ['./modal-auth-debit.component.scss']
})
export class ModalAuthDebitComponent implements OnInit {

  proposalID!: string;
  Token: any;


  constructor(
    private route: Router,
    public api: ApiService,
    public session: SessionService,
    public formalization: FormalizationService,
    public loader: LoadingService,
    public dialogRef: MatDialogRef<ModalAuthDebitComponent>,   
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.Token = this.session.getToken()
  }

  ngOnInit(): void {
  }

  async onLaterClick() {    
    
      this.loader.startLoading()
      this.formalization.debitLater(this.proposalID)
      this.dialogRef.close();

  
    
  }

}
